// Load the installed core-js stable polyfills before any application modules.
// Keep the binding: CRA's preset assumes core-js 3.0 and rewrites bare imports,
// which can discard newer polyfills such as replaceAll needed by Chrome 76.
import stablePolyfills from "core-js/stable";
void stablePolyfills;
